/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_3_Our_1Inputs */



/**
* | output |
* | --- |
* | "Provision of technical infrastructure" |
*
* @param {Guardrails_Section_3_Our_1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_3_our_1 = /** @type {((inputs?: Guardrails_Section_3_Our_1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_3_Our_1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bereitstellung der technischen Infrastruktur")
	return /** @type {LocalizedString} */ ("Provision of technical infrastructure")
});